import React, { useState } from 'react';
import { Container, Divider } from '@mui/material';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { useSignupStore } from 'store/useSignupStore';
import { useTranslation } from 'react-i18next';

export default function SignUpComplete() {
  const { username, name } = useSignupStore();
  // 다국어
  const { t } = useTranslation();
  return (
    <>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column', // 세로 정렬
          justifyContent: 'center', // 수직 중앙 정렬s
          alignItems: 'center', // 수평 중앙 정렬
          height: '100%', // 전체 화면 높이 조절
          marginY: 10
        }}
      >
        <Typography sx={{ mt: 2, mb: 1, textAlign: 'center' }}>
          <CheckCircleOutlinedIcon color="success" style={{ width: '80px', height: '80px' }} />
          <h1 style={{ fontWeight: 'bold', fontSize: '24px' }}> {t('sign_up_complete.complete')}</h1>
          <section style={{ margin: '30px auto' }}>
            {name}({username}){t('sign_up_complete.section1')} <br />
            {t('sign_up_complete.section2')}
          </section>
        </Typography>

        <Button
          component={Link}
          to="/login"
          sx={{ color: 'white', backgroundColor: '#1976d2', width: '167px', height: '42px', margin: '30px auto', fontWeight: 'bold', borderRadius: '4px' }}
        >
          {t('sign_up_complete.login')}
        </Button>
      </Container>
    </>
  );
}
